import React, { useState, useEffect, useContext } from 'react';
import { Link } from "gatsby"
import Layout from '../../components/layout';
import "../../pages/pages.scss"

import BackArrow from "../../images/icons/arrow-left.png"
import QuoteImage from "../../images/icons/quote.png"
import ShareImage from '../../images/icons/share.png'
import LikeImage from '../../images/icons/like.png'
import LikeIconActive from '../../images/icons/like-active.png';
import VerticalLine from '../../images/icons/vertical-line.png'

import BannerImage from "../../components/BannerImage"
import WiseTipSup from '../../components/wideWiseTip'
import WideImageCard2 from "../../components/WideImageCard/WideImageCard2"
import SocialShareButtons from '../../components/common/SocialShareButtons';
import ArrowLeft from '../../images/icons/arrow-left.png';
import ArrowRight from '../../images/icons/right-chevron-dark.png';
import Paragraph from "../../components/common/Paragraph";
import ImageCard from '../../components/common/ImageCard';
import WiseJourney from '../../components/wideWiseJourneyCard';
import UpIcon from '../../images/icons/up-icon.png';
import SEO from '../../components/seo';
import SocialShare from '../../components/common/SocialButtons';
import VideoCard from '../../components/common/VideoBlock';
import { FacebookProvider, Comments } from 'react-facebook';
import { getReadDurationMap, getPlainText, api } from '../../../utils';
import { slice } from 'lodash';
import tracker from '../../../utils/tracker';
import UserContext from '../../context/UserContext';

const Logo = "https://cgs-cdn.sgp1.cdn.digitaloceanspaces.com/parent-wise-prod/website-assets/bg/top-right-pattern.png";

const GATSBY_CMS_SERVER = process.env.GATSBY_CMS_SERVER;

const Quote = (props) => {
    const { data } = props;
    return (
        <div className="pw-qs-main-div">
            <div className="pw-qs-top-line">
                <div className="pw-qs-top-border"/>
                <div className="pw-qs-quote-img">
                    <img loading="lazy" src={QuoteImage} />
                </div>
                <div className="pw-qs-top-border"/>
            </div>
            <div className="pw-quote-content">
                <div className="quote-content">
                    {data}
                </div>
            </div>
            <div className="pw-qs-bottom-border"/>
        </div>
    )
}

const SuperHonestlyDetailTemplate = ({ location, isPreview=false, pageContext: { data, shReadDurationMap } }) => {
    const userData = useContext(UserContext);
    const user = userData && userData.user;
    const [storiesBookmarks, setStoriesBookmarks] = useState([]);
    const [tipsBookmarks, setTipsBookmarks] = useState([]);
    const [wjBookmarks, setWjBookmarks] = useState([]);
    const [openCls, setOpenCls] = useState(false)

    const words = getPlainText(data.acf_super_honestly.description).split(" ");
    const desc = slice(words, 0, 20);

    const bookmarkTip = (slug) => {
        const fData = {
            type: 'super-honestly',
            slug
        }
        api.post('/api/v1/user-bookmark/toggle', fData)
        .then(resp => {
            if (resp && resp.success) {
                fetchStoriesBookmarks();
            } else {
                alert("Something went wrong. Please try again later!");
            }
        });
    }
  
    useEffect(() => {
        if (user) {
          fetchStoriesBookmarks();
          fetchTipsBookmarks();
          fetchWjBookmarks();
        }
    }, [user]);
  
    const fetchStoriesBookmarks = () => {
        api.get('/api/v1/user-bookmark/list/super-honestly')
        .then(resp => {
          if (resp && resp.success && resp.data && resp.data.length) {
            let bookmarks = [];
            resp.data.forEach(i => bookmarks.push(i.slug));
            setStoriesBookmarks(bookmarks);
          } else {
            setStoriesBookmarks([]);
          }
        });
    }

    const fetchTipsBookmarks = () => {
        api.get('/api/v1/user-bookmark/list/wise-tip')
        .then(resp => {
          if (resp && resp.success && resp.data && resp.data.length) {
            let bookmarks = [];
            resp.data.forEach(i => bookmarks.push(i.slug));
            setTipsBookmarks(bookmarks);
          } else {
            setTipsBookmarks([]);
          }
        });
    }

    const fetchWjBookmarks = () => {
        api.get('/api/v1/user-bookmark/list/wise-journey')
        .then(resp => {
          if (resp && resp.success && resp.data && resp.data.length) {
            let bookmarks = [];
            resp.data.forEach(i => bookmarks.push(i.slug));
            setWjBookmarks(bookmarks);
          } else {
            setWjBookmarks([]);
          }
        });
    }

    useEffect(() => {
        updatePostView();
    }, []);

    if (!data || data.status !== 'publish' || !data.acf_super_honestly) {
        return null;
    }

    const updatePostView = () => {
        if (isPreview || !data || data.status !== 'publish' || !data.databaseId) {
            return;
        }
        fetch(`${GATSBY_CMS_SERVER}/wp-json/post-views-counter/view-post`, {
            "headers": {
                'Content-Type': 'application/json'
            },
            "body": JSON.stringify({id: data.databaseId}),
            "method": "POST",
        });
    }

    if (!shReadDurationMap) {
        shReadDurationMap = getReadDurationMap([data])
    }

    const renderContent = (data, prefix) => {
        switch (data.fieldGroupName) {
        case `${prefix}FlexibleContent_Paragraph`:
            return (
                <div className="pw-super-hd-paragraph">
                    <div className="w3-padding-16 w3-content">
                        <Paragraph data={data.content} />
                    </div>
                </div>
            );

            case `${prefix}FlexibleContent_Image`:
            return (
                <div className="pw-super-img-sg">
                    <div className="w3-padding-16 w3-content w3-center">
                        <img loading="lazy" className="pw-super-img" src={data.imageData.sourceUrl} />
                        {(data.picCredit) && (
                            <p className="pw-pic-credit">{data.picCredit}</p>
                        )}
                    </div>
                </div>
            );

        case `${prefix}FlexibleContent_Quote`:
            return (
                <div className="pw-quote-section">
                    <div className="w3-padding-16 w3-content">
                        <Quote data={data.quoteText} />
                    </div>
                </div>
            );

        case `${prefix}FlexibleContent_WiseTip`:
            if (!data.wiseTipCard || !data.wiseTipCard.length) {
                return null;
            }
            return (
                <div className="pw-wide-wisetip-super">
                    <div className="w3-padding-16 w3-content super-ho-de-flexible-cont">
                        <WiseTipSup 
                            data={data.wiseTipCard[0]} customTip={data.customTip} 
                            location={location} user={user} 
                            bookmarks={tipsBookmarks} fetchBookmarks={fetchTipsBookmarks} 
                        />
                    </div>
                </div>
            );

        case `${prefix}FlexibleContent_SuperHonestly`:
            if (!data.superHonestlyCard || !data.superHonestlyCard.length) {
                return null;
            }
            return (
                <div className="pw-super-hd-wide-image-section">
                    <div className="w3-padding-16 w3-content super-ho-de-flexible-wide">
                        <WideImageCard2 
                            data={data.superHonestlyCard[0]} location={location} 
                            shReadDurationMap={shReadDurationMap} user={user} 
                            bookmarks={storiesBookmarks} fetchBookmarks={fetchStoriesBookmarks} 
                        />
                    </div>
                </div>
            );

        case `${prefix}FlexibleContent_WiseSpeak`:
            return (
                <div className="w3-content">
                    {data.wiseSpeakCard.map((card) => 
                        <WiseJourney 
                            data={card} type={"wiseSpeak"} location={location} user={user} 
                            bookmarks={wjBookmarks} fetchBookmarks={fetchWjBookmarks}  
                        />
                    )}
                </div>
            );

        case `${prefix}FlexibleContent_WiseSelf`:
            return (
                <div className="w3-content">
                    {data.wiseSelfCard.map((card) => 
                        <WiseJourney 
                            data={card} location={location} user={user}
                            bookmarks={wjBookmarks} fetchBookmarks={fetchWjBookmarks}
                        />
                    )}
                </div>
            );
        
        case `${prefix}FlexibleContent_VideoBlock`:
            return (
               
                <div className="pw-width-sh ">
                    <VideoCard data={data} />
                </div>
            );

        default:
            return null;
        }
    }

    return (
        <div className="super-ho-de-background">
            <Layout>
                <SEO
                    title={data.title}
                    description={words.length > 20 ? `${desc.join(' ')}...` : `${desc.join(' ')}`}
                    image={(data.acf_super_honestly.bannerImage && data.acf_super_honestly.bannerImage.image) && data.acf_super_honestly.bannerImage.image.sourceUrl}
                    path={location.pathname}
                />
                <div className="pw-super-honestly-detail">
                    <img className="super-ho-logo w3-hide-small w3-hide-medium" src={Logo} />
                    <div className="super-ho-de-back">
                        <Link to="/super-honestly">
                            <img style={{height: "21px"}} src={BackArrow} />
                            <div className="w3-margin-left super-he-do-back">Back to SuperHonestly</div>
                        </Link>
                    </div>
                    <div>
                        <div className="super-ho-de-mo">
                            <div className="super-ho-de"><img loading="lazy" className="super-ho-de-quo" src={QuoteImage} /></div>
                            <div className="w3-content super-ho-de-heading">
                                {data.title}
                            </div>
                        </div>
                        <div className="super-ho-de-subHeader w3-hide-small">
                            <div className="super-ho-de-by">{data.acf_super_honestly.author}</div>
                            <div className="super-ho-de-padding"><img src={VerticalLine} /></div>
                            <div className="super-ho-de-duration">{(shReadDurationMap && shReadDurationMap[data.slug]) ? shReadDurationMap[data.slug] : 'x'} minutes</div>
                            <div className="super-ho-de-padding"><img src={VerticalLine} /></div>
                            <div className={`super-ho-de-padding`}>
                                {(user) && (
                                    <button style={{ background: 'none', padding: '0px', border: 'none', outline: 'none', cursor: 'pointer' }}
                                        onClick={(evt) => {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                            bookmarkTip(data.slug);
                                        }}
                                    > 
                                        <img className="like-img" src={(storiesBookmarks.indexOf(data.slug) !== -1) ? LikeIconActive : LikeImage} />
                                    </button>
                                )}
                            </div>
                            <div className={!openCls ? "w3-show pointer" : "w3-hide"} style={{paddingLeft: "5px"}}>
                                <img src={ShareImage} onClick={() => {setOpenCls(true)}} />
                            </div>
                            <SocialShare data={openCls} handleSetOpenCls={(someData) => {setOpenCls(someData)}} 
                                title={data.title} link={`${location.origin}/super-honestly/${data.slug}`} 
                                subjectTitle={'Check out this story!'} 
                                description={data.acf_super_honestly.description} 
                            />
                        </div>
                        <div className="w3-row w3-hide-large w3-hide-medium pw-super-hd-top-footer">
                            <div className="w3-col s6">
                                <div className="super-ho-de-duration">{(shReadDurationMap && shReadDurationMap[data.slug]) ? shReadDurationMap[data.slug] : 'x'} minutes</div>
                            </div>
                            <div className="w3-col s6">
                                <div className="w3-margin-right" style={{display: "flex", justifyContent: "flex-end"}}>
                                    <div className="">
                                        {(user) && (
                                            <button style={{ background: 'none', padding: '0px', border: 'none', outline: 'none', cursor: 'pointer' }}
                                                onClick={(evt) => {
                                                    evt.preventDefault();
                                                    evt.stopPropagation();
                                                    bookmarkTip(data.slug);
                                                }}
                                            > 
                                                <img className="like-img" src={(storiesBookmarks.indexOf(data.slug) !== -1) ? LikeIconActive : LikeImage} />
                                            </button>
                                        )}
                                    </div>
                                    <div className={!openCls ? "w3-show pointer" : "w3-hide"} style={{paddingLeft: "10px", paddingRight: "20px"}}>
                                        <img src={ShareImage} onClick={() => {setOpenCls(true)}} />
                                    </div>
                                    <SocialShare data={openCls} handleSetOpenCls={(someData) => {setOpenCls(someData)}} 
                                        title={data.title} link={`${location.origin}/super-honestly/${data.slug}`} 
                                        subjectTitle={'Check out this story!'} 
                                        description={data.acf_super_honestly.description} 
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="w3-hide-large w3-hide-medium super-ho-de-by">{data.acf_super_honestly.author}</div>

                        <div className="pw-super-hd-banner-section">
                            <div className="w3-padding-16 pw-super-hd-banner-margin w3-content pw-super-hd-padding">
                                {(data.acf_super_honestly.bannerImage && data.acf_super_honestly.bannerImage.image && data.acf_super_honestly.bannerImage.image.sourceUrl) ?
                                    <div>
                                        <BannerImage url={data.acf_super_honestly.bannerImage.image.sourceUrl} />
                                        {(data.acf_super_honestly.bannerImage.picCredit) && (
                                            <p className="pw-pic-credit">{data.acf_super_honestly.bannerImage.picCredit}</p>
                                        )}
                                    </div>
                                    : null
                                }
                            </div>
                        </div>

                        {(data.acf_super_honestly.flexibleContent && data.acf_super_honestly.flexibleContent.length)
                        ? data.acf_super_honestly.flexibleContent.map((content, idx) => (
                            <div className="w3-row" key={`flexible-data-${idx}`}>
                                {renderContent(content, 'superHonestly_AcfSuperHonestly_')}
                            </div>
                        ))
                        : null}

                        {(data.acf_super_honestly.flexibleContent && data.acf_super_honestly.flexibleContent.length) && <div className="w3-row w3-content pw-scroll-to-top">
                            <img src={UpIcon} onClick={() => window.scroll({ top: 0, behavior: "smooth" })}/>
                        </div>}
                        
                        {(data.tags && data.tags.nodes && data.tags.nodes.length) ?
                            <>
                            <div className="w3-content super-ho-de-tag">Related Tags</div>
                            <div className="pw-sh-tags w3-center">
                                <div className="w3-content">
                                    {data.tags.nodes.map((item, idx) => {
                                        return (
                                            <Link onClick={() => tracker.trackEvent('Related Tags', 'Click', `[${item.name}]-[${data.slug}]`)} className="pw-sh-related-tags" to={`/super-honestly-tags?tags=${item.slug}`}>
                                                {item.name}{data.tags.nodes.length == idx+1 ? '' : ', '}
                                            </Link>
                                        )
                                    })}
                                </div>
                            </div>
                            </>
                            : null
                        }

                        <div className="super-ho-de w3-padding-16">
                            <div>
                                <SocialShareButtons 
                                    title={data.title} 
                                    link={`${location.origin}/super-honestly/${data.slug}`}
                                    subjectTitle={'Check out this story!'} 
                                    description={data.acf_super_honestly.description} 
                                />
                            </div>
                        </div>
                        
                        <div className="w3-row pw-super-hd-paragraph" style={{ paddingBottom: '20px' }}>
                            <div className="w3-content">
                                <FacebookProvider appId="172195227833440">
                                    <Comments href={`${process.env.GATSBY_SITE_URL}/super-honestly/${data.slug}`} />
                                </FacebookProvider>
                            </div>
                        </div>

                        {(data.nextSuperHonestly || data.previousSuperHonestly) ?
                            <div className="w3-row super-ho-de-prev-main prev-border w3-content">
                                {(data.previousSuperHonestly && data.previousSuperHonestly.node && data.previousSuperHonestly.node.status === 'publish') && (
                                    <div className="w3-col s6 m6 trending-border-right w3-left">
                                        <Link to={`/super-honestly/${data.previousSuperHonestly.node.slug}`}>
                                            <div className="super-ho-de-prev-sub">
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                                    <img style={{width: "13px", marginTop:30}} src={ArrowLeft} />
                                                </div>
                                                <div className="super-ho-de-prev-desc">
                                                    <div className="w3-row super-ho-de-prev">Previous</div>
                                                    {data.previousSuperHonestly.node.title}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ) || (<div className="w3-col s6 m6">&nbsp;</div>)}
                                {(data.nextSuperHonestly && data.nextSuperHonestly.node && data.nextSuperHonestly.node.status === 'publish') && (
                                    <div className="w3-col s6 m6 w3-right">
                                        <Link to={`/super-honestly/${data.nextSuperHonestly.node.slug}`}>
                                            <div className="super-ho-de-next-sub">
                                                <div className="super-ho-de-next-desc">
                                                    <div className="w3-row super-ho-de-next">Next</div>
                                                    {data.nextSuperHonestly.node.title}
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                                    <img style={{width: "13px",marginTop:30}} src={ArrowRight} />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ) || (<div className="w3-col s6 m6">&nbsp;</div>)}
                            </div>
                            : null
                        }
                        
                        {data.acf_super_honestly.relatedStories && data.acf_super_honestly.relatedStories.length ?
                            <div className="pw-more-st-sc">
                                <div className="w3-content">
                                    <div className="super-ho-most-read">More stories for you</div>
                                    <div className="w3-row w3-row-padding w3-hide-small super-ho-re-stories">
                                        {data.acf_super_honestly.relatedStories.map((story) => <ImageCard page={story} shReadDurationMap={shReadDurationMap} /> )}
                                    </div>
                                    <div className="w3-hide-large w3-hide-medium super-ho-re-stories">
                                        {data.acf_super_honestly.relatedStories.map((story) => <ImageCard page={story} shReadDurationMap={shReadDurationMap} /> )}
                                    </div>
                                </div>
                            </div>
                        : null }

                    </div>
                </div>
            </Layout>
        </div> 
    )
}

export default SuperHonestlyDetailTemplate
